export default __webpack_public_path__ + "static/6-6d63a14fc3c7138a19072c7937c8f730.jpg";